// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[production]8.0.21-13230(8d611147fc)-C24/09/2026-17:55:26-B24/09/2026-18:04:44' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[production]8.0.21-13230(8d611147fc)-C24/09/2026-17:55:26-B24/09/2026-18:04:44",
  branch: "production",
  latestTag: "8.0.21",
  revCount: "13230",
  shortHash: "8d611147fc",
  longHash: "8d611147fc563c44fa17080cdace4aac665767ac",
  dateCommit: "24/09/2026-17:55:26",
  dateBuild: "24/09/2026-18:04:44",
  buildType: "Ansible",
  } ;
